import { Button, FormControlSizes, type OptionTypeEnum, useCallbackRef } from '@talos/kyoko';
import { primeNewRFQForm } from '../../../../../components/OMS/NewRFQ/RFQSlice';
import { openView } from '../../../../../components/OMS/OMSSlice';
import { OMSView } from '../../../../../components/OMS/OMSView';
import { useAppStateDispatch } from '../../../../../providers/AppStateProvider';
import type { OptionChainDataRow } from '../types';

export const OptionChainPrimeRFQButton = ({ row, side }: { row: OptionChainDataRow; side: OptionTypeEnum }) => {
  const dispatch = useAppStateDispatch();

  const handleClick = useCallbackRef(() => {
    const symbol = row[side]?.Symbol;

    if (!symbol) {
      return;
    }

    dispatch(openView(OMSView.RFQForm));
    dispatch(primeNewRFQForm({ symbol }));
  });

  return (
    <Button
      data-testid={`option-chain-prime-${side}-button`}
      size={FormControlSizes.Small}
      onClick={handleClick}
      width="65px"
    >
      RFQ {side}
    </Button>
  );
};
